import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthLog } from './models/auth-log.model';
import { AuthLogsService } from './auth-logs.service';
import { ToastrService } from 'ngx-toastr';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthLogFilter } from './models/auth-log-filter.model';

@Component({
  selector: 'app-auth-logs',
  templateUrl: './auth-logs.component.html',
  styleUrls: ['./auth-logs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthLogsComponent implements OnInit {
  public isLoading = false;

  public authLogs: AuthLog[] = [];

  public columnMode = ColumnMode;
  public rerenderTable = false;
  public filterText = '';

  public filter: AuthLogFilter;

  constructor(
    private authLogsService: AuthLogsService,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.clearFilters();
    this.getAuthLogs();
  }

  getAuthLogs() {
    this.isLoading = true;
    this.authLogs = [];

    this.authLogsService.getAuthLogs(this.filter)
      .subscribe((logs: Array<AuthLog>) => {
        this.authLogs = logs;
        this.isLoading = false;

        this.rerenderTable = true;
        setTimeout(() => this.rerenderTable = false, 1);
      })
  }

  get hasFilters() {
    return this.filter.searchText.trim() ||
      this.filter.startDate ||
      this.filter.endDate ||
      this.filter.logTypeId ||
      this.filter.userId;
  }

  clearFilters() {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 1); // Default to last day's logs

    this.filter = {
      searchText: '',
      logTypeId: null,
      logTypeName: null,
      startDate: startDate,
      endDate: new Date(),
      userId: null,
      userName: null,
      errorsOnly: false
    }

    this.getAuthLogs();
  }

  filterByDate() {
    this.getAuthLogs();
  }

  filterByLogType(authLog: AuthLog) {
    this.filter.logTypeId = authLog.logTypeId;
    this.filter.logTypeName = authLog.logType;

    this.getAuthLogs();
  }

  filterByUser(authLog: AuthLog) {
    this.filter.userId = authLog.userId;
    this.filter.userName = authLog.userName;

    this.getAuthLogs();
  }

  filterByErrorsOnly() {
    this.getAuthLogs();
  }

  removeTypeFilter() {
    this.filter.logTypeId = null;
    this.filter.logTypeName = null;

    this.getAuthLogs();
  }

  removeUserFilter() {
    this.filter.userId = null;
    this.filter.userName = null;

    this.getAuthLogs();
  }

  public refresh() {
    this.getAuthLogs();
  }

  public copyToClipboard(row: AuthLog) {
    (navigator as any).clipboard.writeText(row.userId);
    this.toastrService.success('User ID copied to clipboard.');
  }

  getTimestampString(timestamp: Date) {
    const date = new Date(timestamp);
    const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    return `${utcDate.toLocaleDateString()} ${utcDate.toLocaleTimeString()}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/logs/auth-logs/auth-logs.component.ts